<ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
  <ziro-select [fieldId]="'readOnlySecurityGroupList'"></ziro-select>
  <ziro-select [fieldId]="'writeSecurityGroupList'"></ziro-select>
</ziro-collapsible-section-card>
